/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import { Box, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import roundToNearestMinutes from "date-fns/roundToNearestMinutes";

const useStyle = makeStyles((theme: Theme) => ({
    timePickerWrapper: {
        position: "relative",
        marginLeft: 10,
        [theme.breakpoints.down("xs")]: {
            marginTop: 10,
            marginLeft: 0,
        },
    }
}));

const TimePickerComonent = ({setDefault=false, handleChange = (val) => {}, disabled=false, outlined=false, error=false}) => {
    const [selectedDate, handleDateChange] = useState(new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate()));
    useEffect(() => {
        const rounded = roundToNearestMinutes(selectedDate, { nearestTo: 5 });
        handleChange(rounded);
    }, [selectedDate]);
    useEffect(() => {
        if(setDefault) {
            const rounded = roundToNearestMinutes(new Date(), { nearestTo: 5 });
            handleDateChange(rounded);
        }
    }, []);
    const classes = useStyle();
    const handleTimeChange = (date) => {
        const rounded = roundToNearestMinutes(date, { nearestTo: 5 });
        handleDateChange(rounded);
    };
    return (
        <Box className={classes.timePickerWrapper}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                    autoOk
                    emptyLabel=""
                    value={selectedDate}
                    disabled={disabled}
                    onChange={handleTimeChange}
                    minutesStep={5}
                    error={error}
                    inputVariant={!outlined ? "outlined": "standard"}
                />
            </MuiPickersUtilsProvider>
        </Box>
    );
};

export default TimePickerComonent;
